import { PropertyHelper } from '@/helpers/property.helper';
import { AppConfigService } from '@/services/app-config.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  Document,
  DocumentCategory,
  DocumentType,
  PropertyEquipment,
  PropertyMaintenance,
  PropertyWork,
  RealProperty,
  RescueService,
  VaultService
} from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PropertyDocCardComponent } from '../property-doc-card/property-doc-card.component';
import { NgIf, NgFor } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-property-doc-view',
    templateUrl: './property-doc-view.component.html',
    styleUrls: ['./property-doc-view.component.scss'],
    standalone: true,
    imports: [MatExpansionModule, NgIf, NgFor, PropertyDocCardComponent]
})
export class PropertyDocViewComponent implements OnInit, OnDestroy {
  @Input() prop: RealProperty;
  @Input() category: DocumentCategory;
  @Input() works?: PropertyWork[];
  @Input() maintenances?: PropertyMaintenance[];
  @Input() equipments?: PropertyEquipment[];
  @Input() rescueMode = false;

  hasDoc = false;
  expanded = false;
  panelDescription: string;
  docs: { [key: string]: Document[] } = {};
  docGroups: string[] = [];
  docGroupTitles: { [key: string]: string } = {};
  docsCount: number;

  sub = new Subscription();

  constructor(
    private vaultService: VaultService,
    private rescueService: RescueService,
    private appConfigService: AppConfigService,
    private propHelper: PropertyHelper
  ) {}

  ngOnInit() {
    this.loadDocList();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  loadDocList() {
    this.docsCount = 0;
    this.docs = {};
    this.docGroups = [];
    this.hasDoc = false;
    if (this.rescueMode) {
      this.sub = this.rescueService.getRealPropertyRescuePlans(this.prop.uid).subscribe((data) => {
        data.forEach((doc) => {
          const group = doc.type;
          if (!this.docGroups.includes(group)) {
            this.docGroups.push(group);
          }
          if (!this.docs[group]) {
            this.docs[group] = [];
          }
          this.docs[group].push(doc);
          this.docsCount++;
        });
        this.hasDoc = this.docsCount > 0;
        this.panelDescription = this.getPanelDescription();
        this.expanded = this.hasDoc;
        this.docGroups.forEach((g) => (this.docGroupTitles[g] = this.getGroupTitle(g)));
      });
    } else {
      this.sub = this.vaultService.getRealPropertyDocuments(this.prop.uid, this.category).subscribe((data) => {
        data.forEach((doc) => {
          const group = doc.linkObjectId ? doc.linkObjectId : doc.type;
          if (!this.docGroups.includes(group)) {
            this.docGroups.push(group);
          }
          if (!this.docs[group]) {
            this.docs[group] = [];
          }
          this.docs[group].push(doc);
          this.docsCount++;
        });
        this.hasDoc = this.docsCount > 0;
        this.panelDescription = this.getPanelDescription();
        this.expanded = this.appConfigService.isDesktop && this.hasDoc;
        this.docGroups.forEach((g) => (this.docGroupTitles[g] = this.getGroupTitle(g)));
      });
    }
  }

  getGroupTitle(group: string) {
    if (this.works) {
      const work = this.works.find((i) => i.uid === group);
      if (work) {
        return work.summary;
      }
    }
    if (this.maintenances) {
      const maint = this.maintenances.find((i) => i.uid === group);
      if (maint) {
        return maint.summary;
      }
    }
    if (this.equipments) {
      const equipment = this.equipments.find((i) => i.uid === group);
      if (equipment) {
        return equipment.name;
      }
    }
    return this.propHelper.getDocumentTypeName(DocumentType[group]);
  }

  getPanelDescription() {
    const valuesCount = this.docsCount;
    switch (valuesCount) {
      case 0:
        return 'Aucun document';
      case 1:
        return '1 document';
      default:
        return valuesCount + ' documents';
    }
  }
}
